var social_icons = (function ($) {

    var _init = function () {
        var social_icons = $('#header-social-icons');
        var mobile_menu = $('#mobile_menu');

        if (social_icons.length && mobile_menu.length) {
            var cloned_icons = social_icons.clone();
            cloned_icons.removeClass('desktop');
            cloned_icons.addClass('responsive');
            mobile_menu.append(cloned_icons);
        }
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = social_icons;